var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1689 59.4392C49.4908 62.1662 46.4786 63.9845 43.0417 63.9845C41.3054 63.9845 39.6775 63.5204 38.2753 62.7096C36.873 63.5204 35.2451 63.9845 33.5088 63.9845C28.7545 63.9845 24.8128 60.5051 24.0912 55.9538C24.0519 55.9542 24.0126 55.9544 23.9733 55.9544C17.8752 55.9544 12.9316 51.0109 12.9316 44.9127C12.9316 42.9016 13.4693 41.0161 14.4088 39.392C13.4693 37.7679 12.9316 35.8824 12.9316 33.8713C12.9316 27.7732 17.8751 22.8297 23.9731 22.8296L23.9731 22.8198H24.5015C28.9029 22.8198 32.5128 26.2083 32.8647 30.519L26.7823 46.3841C26.4199 47.3293 26.8924 48.3893 27.8376 48.7517C28.7828 49.1141 29.8428 48.6416 30.2052 47.6964L31.5864 44.0938L38.2835 44.0935L39.6648 47.6964C40.0272 48.6416 41.0872 49.1141 42.0324 48.7517C42.9776 48.3893 43.4501 47.3293 43.0877 46.3841L36.6465 29.583C36.5794 29.408 36.4874 29.2478 36.3755 29.1056C35.391 23.5156 30.5556 19.2532 24.7066 19.1556C26.1452 15.7131 29.5445 13.2939 33.5088 13.2939C35.2451 13.2939 36.873 13.758 38.2753 14.5688C39.6775 13.758 41.3054 13.2939 43.0417 13.2939C48.3081 13.2939 52.5774 17.5632 52.5774 22.8296C58.6755 22.8297 63.6189 27.7732 63.6189 33.8713C63.6189 35.8824 63.0812 37.7679 62.1418 39.392C63.0812 41.0161 63.6189 42.9016 63.6189 44.9127C63.6189 51.0109 58.6754 55.9544 52.5772 55.9544L52.5307 55.9543L52.5045 55.9541C49.9085 55.64 47.897 53.4291 47.897 50.7483V47.1076C47.8978 47.0851 47.8982 47.0625 47.8982 47.0399L47.8982 30.2442C47.8982 29.2319 47.0775 28.4112 46.0653 28.4112C45.053 28.4112 44.2323 29.2319 44.2323 30.2442L44.2324 45.5294H44.2312V50.7483C44.2312 54.9914 47.1971 58.5417 51.1689 59.4392ZM36.8781 40.4277L34.935 35.3594L32.9918 40.4279L36.8781 40.4277Z",
    fill: "url(#paint0_linear_2137_19286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19286",
    x1: 38.2754,
    y1: 13.2939,
    x2: 6.5323,
    y2: 61.1413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E88822"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution1);
export default __webpack_public_path__ + "static/media/awsSolution1.91ff546525dab5eb9fdad7dbe788911d.svg";
export { ForwardRef as ReactComponent };